import React, { useEffect } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import { updateTermsAndConditions } from 'api/cart/cartTermsAndConditions'
import { useIntl } from 'react-intl'

interface Props {
  cartId: string
}

function TermsAndConditionsAcknowledgedModal({ cartId }: Props) {
  const intl = useIntl()

  useEffect(() => {
    updateTermsAndConditions(cartId, {
      accepted: true,
      acceptedAt: new Date().toISOString(),
    })
  }, [cartId])

  return (
    <ModalBase>
      <ModalHeader title={intl.formatMessage({
        id: 'G5NkntbAv9',
        defaultMessage: 'Thank you for reviewing the terms and conditions',
        description: 'Modal title shown after customer acknowledges T&Cs',
      })}
      />
      <ModalBody>
        <ModalContent>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'YY7Vf1DUzx',
              defaultMessage: 'Your acknowledgement has been recorded.',
              description: 'Confirmation message after T&Cs acknowledgement is saved',
            })}
          </BodyText>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: 'V2VDdXDV+t',
            defaultMessage: 'Close',
            description: 'Close button for T&Cs acknowledged modal',
          }),
        }}
      />
    </ModalBase>
  )
}

export default TermsAndConditionsAcknowledgedModal
